module.exports = __webpack_public_path__ + "img/sv23.a4412306.svg";